const en = {
  nav: {
    home: "home",
    ourStory: "our story",
    menus: "menus",
    specialMenus: "special menus",
    gallery: "gallery",
    locations: "locations",
    contact: "contact",
    privateEvents: "private events",
    comingSoon: "coming soon",
  },
  home: {
    hero: {
      subtitle: "Authentic Northern Italian & French Cuisine",
      description: "From Chicago to Guatemala, three generations of culinary excellence. Handcrafted fresh pasta, the finest wines, and a unique dining experience.",
      viewMenus: "View Our Menus",
    },
    legacy: {
      title: "A Chicago Legacy, Now Global",
      p1: 'Since 1985, Carlos & Carlos has been a benchmark of Franco-Italian haute cuisine in Chicago. Founded by the Montiel brothers, our white-tablecloth restaurant in Arlington Heights quickly earned a place among the culinary elite, attracting celebrities like Tom Cruise, Robert De Niro, and Paul Newman.',
      p2: 'Today, with three locations in two countries, we continue to honor our tradition of handmade fresh pasta, premium cuts of meat, and an incomparable wine list.',
      btn: "Our Story",
    },
    counters: {
      years: "Years of Tradition",
      yearsDesc: "Serving excellence since 1985 in Chicago",
      locations: "Locations",
      locationsDesc: "Arlington Heights · Wilmette · Antigua",
      dishes: "Signature Dishes",
      dishesDesc: "A curated menu of Northern Italian & French classics",
    },
    infoCards: {
      pasta: "Artisanal Pasta",
      pastaDesc: "Fresh pasta made in-house daily, following traditional Italian recipes",
      ingredients: "Premium Ingredients",
      ingredientsDesc: "The finest ingredients imported from Italy and fresh local products",
      wine: "Wine List",
      wineDesc: "Extensive selection of Italian and international wines, carefully curated",
      ambiance: "Elegant Ambiance",
      ambianceDesc: "Impeccable service in a sophisticated white-tablecloth setting",
    },
    locations: {
      title: "Our Locations",
      subtitle: "Three locations, two countries, one tradition.",
      antigua: "Antigua Guatemala",
      antiguaDesc: "Coming soon",
      comingSoonNote: "Coming soon to a new location in Antigua Guatemala.",
      wilmette: "Wilmette, IL",
      wilmetteDesc: "615 Green Bay Road, Wilmette · 847-920-5058",
      arlington: "Arlington Heights, IL",
      arlingtonDesc: "27 West Campbell Ave, Arlington Hts · 847-259-2600",
      viewDetails: "View Details",
    },
    reserve: {
      title: "Reserve Your Table",
      description: "We would be honored to provide you with a unique dining experience, excellent service, in addition to the ambiance, comfort and location.",
    },
    giftCards: {
      title: "Gift Cards Available",
      description: "Give the gift of an unforgettable dining experience. Perfect for any occasion.",
      action: "More Information",
    },
  },
  about: {
    hero: {
      title: "Our Story",
      subtitle: "Since 1985 — A legacy of Italian excellence.",
    },
    title: "Chicago 1985",
    p1: 'In early 1985, CARLOS MONTIEL and his brother EDDY MONTIEL opened a small restaurant that would eventually change the way Chicago dines. They ventured into a place no one else dared to open, leaving only a Northern Italian white-tablecloth restaurant.',
    p2: 'Making fresh pasta in front of diners and with tuxedoed waitstaff, Carlos & Carlos began a wonderful gastronomic journey. Signature dishes like Black Pasta with shrimp and scallops in champagne cream sauce, Veal Carlos with porcini mushrooms and cream sauce, and poached fresh salmon with lobster sauce earned Carlos & Carlos a place among Chicago\'s elite restaurants.',
    p3: 'This small, cozy restaurant became a magnet for Chicago\'s high society, attracting personalities such as Tom Cruise, Robert De Niro, Paul Newman, Julia Roberts, and designer Oscar de la Renta, among many others.',
    cards: {
      established: "Est. 1985",
      establishedDesc: "Founded in Chicago by the Montiel brothers with an audacious vision",
      cuisine: "Franco-Italian Cuisine",
      cuisineDesc: "Unique fusion of Northern Italian and French cuisine",
      recognition: "International Recognition",
      recognitionDesc: "Acclaimed by critics and celebrities from around the world",
      locations: "3 Locations",
        locationsDesc: "Arlington Heights, Wilmette and Antigua Guatemala",
    },
    milestones: {
      title: "Our History",
      chicago: "Chicago",
      chicagoDesc: "The Montiel brothers open the doors of the first Carlos & Carlos in Chicago, in the heart of Arlington Heights. With a unique fusion of Northern Italian and French cuisine, it soon hosted great icons like Tom Cruise, Robert De Niro, Paul Newman and Julia Roberts.",
      guatemala: "Guatemala",
      guatemalaDesc: "After achieving international success, Carlos & Carlos expands and opens its doors at La Aurora International Airport in Guatemala City, offering high-quality dishes made with artisanal pasta.",
      antigua: "Antigua Guatemala",
      antiguaDesc: "Carlos & Carlos makes its debut in Antigua Guatemala on January 12, 2023, offering a variety of high-quality dishes, an extensive wine selection, and expanding a legacy of international recognition.",
    },
  },
  contact: {
    hero: {
      title: "Contact Us",
      subtitle: "We'd love to hear from you.",
    },
    title: "Get In Touch",
    description: "We would be honored if you choose Carlos & Carlos for your next visit. We will be delighted to provide you with a unique dining experience.",
    reservations: "Reservations",
    form: {
      select: "Select a restaurant",
      antigua: "Antigua Guatemala",
      wilmette: "Wilmette, IL",
      arlington: "Arlington Heights, IL",
      name: "Full Name",
      namePlaceholder: "Your full name",
      email: "Email Address",
      emailPlaceholder: "your@email.com",
      subject: "Subject",
      subjectPlaceholder: "How can we help you?",
      message: "Your Message",
      messagePlaceholder: "Tell us more about your inquiry...",
      send: "Send Message",
    },
  },
  menus: {
    hero: {
      title: "Our Menu",
      subtitle: "Northern Italian & French cuisine. Artisanal pasta since 1985.",
    },
    antiguaClosed: "Antigua Guatemala",
    antiguaClosedDesc: "We are excited to announce that we will soon be opening our doors at a new location within Antigua Guatemala. Thank you for your patience and support! Stay tuned for more details.",
  },
  specialMenus: {
    hero: {
      title: "Special Menus",
      subtitle: "New special menus coming soon.",
    },
    comingSoon: "Coming Soon!",
    comingSoonDesc: "We are working on new special menus for you. Antigua Guatemala is relocating to a new location within the city. We look forward to serving you soon!",
  },
  gallery: {
    hero: {
      title: "Gallery",
      subtitle: "Explore our restaurants.",
    },
  },
  locations: {
    hours: "HOURS",
    visitOther: "Visit Our Other Locations",
    antiguaClosed: "Antigua Guatemala — Temporarily Closed",
    antiguaClosedDesc: "Coming soon to a new location in Antigua Guatemala.",
  },
  privateEvents: {
    hero: {
      title: "Private Events",
      subtitle: "Celebrate with us — an exclusive dining experience.",
    },
    title: "Coordinate Your Special Event",
    description: "At Carlos & Carlos, we are delighted to host private events during lunch and dinner hours. Whether it's a corporate gathering, family celebration, or an intimate party, our team will ensure every detail is perfect.",
    details: "We offer versatile spaces and a customizable menu to suit your needs. Our first-class service and exceptional cuisine will make your event an unforgettable experience.",
    call: "Call us to book or request more information.",
    moreInfo: "More Information",
    phones: "Reservations",
  },
  footer: {
    locations: "locations",
    company: "company",
    ourstory: "our story",
    menus: "menus",
    gallery: "gallery",
    contact: "contact",
    AntiguaGuatemala: "Antigua Guatemala",
    WilmetteIL: "Wilmette, IL",
    ArlingtonHeightsIL: "Arlington Heights, IL",
  },
};

export default en;
